import { t } from "i18next";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import React from "react";
import useFormStyles from "../KPIsForm/themes";
import DatePicker from "../components/DatePicker";
import FormikInputField from "./../form/FormikInputField";

type Props = {
  disabled?: boolean;
  currentStartDate: string | undefined;
  currentEndDate: string | undefined;
  unitId: string;
  units: { id: string; name: string }[];
  periodlevelId: string;
  setVisiblePeriods: (
    periodlevelId: string,
    startDate: string,
    endDate: string
  ) => void;
};

const ScheduleAndBudgetForm = (props: Props) => {
  const classes = useFormStyles();
  const rtl = useAppContext((ctx) => ctx.rtl);
  const currentUnit = props.units.find((u: any) => u.id === props.unitId);
  return (
    <>
      <div className={classes.formWrapper}>
        <div className={classes.formColumn}>
          <h1 style={{ marginTop: "40px" }} className={classes.formTitle}>
            {t("initiatives.Schedule and Budget")}
          </h1>
          <div className={classes.flexRow}>
            <DatePicker
              name="scheduleAndBudget.Project Start Date"
              placeholder={t("initiatives.Select Start Date")}
              label={t("initiatives.Planned Start Date")}
              isStartDate={true}
              minDate={new Date("2010")}
              maxDate={
                props.currentEndDate
                  ? new Date(props.currentEndDate)
                  : new Date("2040")
              }
              {...props}
            />
            <DatePicker
              name="scheduleAndBudget.Project End Date"
              placeholder={t("initiatives.Select End Date")}
              label={t("initiatives.Planned End Date")}
              isStartDate={false}
              minDate={
                props.currentStartDate
                  ? new Date(props.currentStartDate)
                  : new Date("2010")
              }
              maxDate={new Date("2040")}
              {...props}
            />
          </div>
          <FormikInputField
            name="scheduleAndBudget.budget"
            placeholder={t("Enter Budget")}
            label={t("initiatives.Budget")}
            prefix={
              currentUnit
                ? t(`units.${currentUnit.name}`, currentUnit.name)
                : ""
            }
            type="number"
            dir={rtl ? "rtl" : "ltr"}
            {...props}
          />
        </div>
      </div>
    </>
  );
};

export default ScheduleAndBudgetForm;
